/* eslint-disable no-restricted-globals */
import React, { useState } from "react";
import { H6, Image, LI, P, UL } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import SvgIcon from "../../../Utils/CommonComponents/CommonSvgIcons";
import { useSelector } from "react-redux";
import { RootState } from "../../../ReduxToolkit/Store";

export default function UserWrap() {
  const { user } = useSelector((state: RootState) => state.auth);
  const [open, setOpen] = useState(false);

  const toggle = () => {
    setOpen(!open);
  };
  const logout = () => {
    localStorage.clear();
    location.reload();
  };
  return (
    <li className="profile-nav custom-dropdown">
      <div className="user-wrap" onClick={toggle}>
        <div className="user-img">
          <Image src={dynamicImage(`profile.png`)} alt="user" />
        </div>
        <div className="user-content">
          <H6>{user?.name}</H6>
          <P
            className="mb-0"
            style={{
              maxWidth: "120px",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {user?.role}
            <i className="fa-solid fa-chevron-down" />
          </P>
        </div>
      </div>
      <div className={`custom-menu overflow-hidden ${open ? "show" : ""}`}>
        <UL className="profile-body simple-list">
          {/* {settingIconData.map((item) => (
            <LI className="d-flex" key={item.id}>
              <SvgIcon className="svg-color" iconId={item.icon} />
              <h6 className="ms-2">{item.text}</h6>
            </LI>
          ))} */}
          <LI className="d-flex" onClick={logout}>
            <SvgIcon className="svg-color" iconId="Login" />
            <h6 className="ms-2">{"Log Out"}</h6>
          </LI>
        </UL>
      </div>
    </li>
  );
}
